const pluralRules = new Intl.PluralRules('ru');
export const declineWord = (number: number, words: Record<string, string>) => {
  return `${number} ${words[pluralRules.select(number)]}`;
};
